import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms'
import { IfObservable } from 'rxjs/observable/IfObservable';
@Component({
  selector: 'datos-matricula',
  template: `
    <form name="form-inscripciones" [formGroup]="cursoAlumno">
      <div class="row mt-3">
        <label class="col-sm-2 col-form-label text-right"> 
          Matrícula: </label>
        <div class="col-sm-2 pr-0">
          <div
            class="input-group input-group-sm ">
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="matricula"
              
              >
          </div>
        </div>
        <label class="col-sm-1 col-form-label text-right"> 
          Folio: </label>
        <div class="col-sm-1 pr-0">
          <div
            class="input-group input-group-sm ">
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="folio"
              >
          </div>
        </div>
        <label class="col-sm-3 col-form-label text-right"> 
          Número de matricula: </label>
        <div class="col-sm-3 p-0 form-radio">
          <div class="radio radio-inline" *ngFor="let item of matriculas">
            <label>
                <input 
                type="radio" 
                name="numeroMatricula" 
                [value]="item.id" 
                formControlName="numeroMatricula">
                  <i class="helper"></i> {{item.descripcion}}
            </label>
          </div>
        </div>
      </div>
    </form>
  `,
  styles: []
})
export class DatosMatriculaComponent implements OnInit {
  @Input() cursoAlumno: FormGroup

  public matriculas: any = []
  constructor() { }

  ngOnInit() {
    this.matriculas =[
      {id:1, descripcion:"1 ra"},
      {id:2, descripcion:"2 da"},
      {id:3, descripcion:"3 ter"}
    ]
    if(this.cursoAlumno.get('numeroMatricula').value ==  null)
      this.cursoAlumno.patchValue({numeroMatricula:1})
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-matricula.component.ts